import React from "react";     
import LockScreenForm from "../../components/Auth/LockScreenForm";

const LockScreen = () => {
  return (
    <>
      <LockScreenForm />
    </>
  );
};

export default LockScreen;
